import React, { FunctionComponent, useState } from 'react';
import AppPage from '../../layout/appPage/AppPage';
import { Button, Form, Input } from 'antd';
import styles from './HelpDeskPage.module.scss';
import { ANTD_COLS } from '../../constants/markup';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { HelpDeskTaskRequest } from '../../types/apiDomain';
import appNotification from '../../utils/ui/appNotification';
import displayErrorNotification from '../../utils/ui/displayErrorNotification';
import getErrorMessage from '../../utils/getErrorMessage';
import requestHelpDeskTask from '../../actions/api/jira/requestHelpDeskTask';
import TextArea from 'antd/lib/input/TextArea';

const LABEL_COL = 5;

interface InternalProps {
    form: WrappedFormUtils;
}

const HelpDeskPage: FunctionComponent<InternalProps> = ({ form }) => {
    const { getFieldDecorator, validateFields } = form;

    const [isRequestLoading, setIsRequestLoading] = useState<boolean>(false);

    const handleFormSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        validateFields(async (errors, values) => {
            if (errors) {
                return;
            }

            const requestData = values as HelpDeskTaskRequest;

            setIsRequestLoading(true);
            try {
                const response = await requestHelpDeskTask(requestData);

                const createdTaskKey = response.response?.creation?.key;
                const creationMessage = createdTaskKey ? `Задача ${createdTaskKey} успешно создана` : response.message;

                appNotification.success({
                    message: 'Запрос создан',
                    description: (
                        <div>
                            <p>{creationMessage}</p>
                            <p>
                                <a href={response.issueUrl} target="_blank" rel="noopener noreferrer">
                                    {response.issueUrl}
                                </a>
                            </p>
                        </div>
                    ),
                    duration: 0
                });
            } catch (error) {
                displayErrorNotification(getErrorMessage(error), 'Произошла ошибка при запросе');
            } finally {
                setIsRequestLoading(false);
            }
        });
    };

    return (
        <AppPage title="Help Desk">
            <Form
                className={styles.form}
                labelCol={{ span: LABEL_COL }}
                wrapperCol={{ span: ANTD_COLS - LABEL_COL }}
                onSubmit={handleFormSubmit}
            >
                <Form.Item label="Заголовок">
                    {getFieldDecorator('title', {
                        rules: [
                            {
                                required: true,
                                whitespace: true,
                                message: 'Укажите заголовок задачи'
                            }
                        ]
                    })(<Input type="text" placeholder="Заголовок задачи" readOnly={isRequestLoading} />)}
                </Form.Item>
                <Form.Item label="Описание">
                    {getFieldDecorator('description', {
                        rules: [
                            {
                                required: true,
                                whitespace: true,
                                message: 'Укажите описание задачи'
                            }
                        ]
                    })(<TextArea placeholder="Описание задачи" readOnly={isRequestLoading} />)}
                </Form.Item>
                <Form.Item wrapperCol={{ span: ANTD_COLS - LABEL_COL, offset: LABEL_COL }}>
                    <Button type="primary" htmlType="submit" loading={isRequestLoading}>
                        Создать задачу
                    </Button>
                </Form.Item>
            </Form>
        </AppPage>
    );
};

export default (Form.create()(HelpDeskPage) as unknown) as FunctionComponent;
